import React from 'react'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { getErrorMessage } from '../utils'
import { TAddInsuranceContactInformationModalSchema } from './AddInsuranceContactInformationModalSchema'
import { useAddInsuranceContactInformationModalFormContext } from './useAddInsuranceContactInformationModalForm'

interface IInsuranceContactInformatiomFormField {
  name: keyof TAddInsuranceContactInformationModalSchema
  placeholder: string
  label: string
  type?: string
}
const InsuranceContactInformatiomFormField = ({
  label,
  name,
  placeholder,
  type = 'text',
}: IInsuranceContactInformatiomFormField) => {
  const { control, errors } = useAddInsuranceContactInformationModalFormContext()
  return (
    <ControlledTextField
      name={name}
      control={control}
      TextInputProps={{
        type,
        validationMessage: getErrorMessage(errors, name),
        error: !!getErrorMessage(errors, name),
        placeholder,
        required: true,
        dataTest: `input-${name}`,
        label,
      }}
    />
  )
}

export default InsuranceContactInformatiomFormField
